import { Lightbulb } from "lucide-react";

export const DepartmentalAutonomyTakeaway = () => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-xl p-6">
      <div className="flex items-start gap-4">
        <div className="p-2 bg-primary/10 rounded-lg shrink-0">
          <Lightbulb className="h-5 w-5 text-primary" />
        </div>
        <div>
          <h2 id="key-takeaway" className="text-lg font-semibold text-foreground mb-2">Key Takeaway</h2>
          <p className="text-muted-foreground">
            <strong>The biggest hierarchy problem is top-down, not bottom-up.</strong> Employees know to escalate through their manager. The chaos comes when executives bypass the chain going downward—messaging developers directly, giving feedback to skip-levels, or assigning tasks without the manager's knowledge. Every time you skip a level, you undermine that manager's authority and create confusion about who's really in charge.
          </p>
        </div>
      </div>
    </div>
  );
};
